export default __webpack_public_path__ + "digital-marketing.5c39a1ad.png";